
import React from 'react';
import { Building, TrendingUp } from 'lucide-react';
import TranslatedText from '@/TranslatedText';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

const SellPortalHero: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-ahavex-blue to-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="md:flex md:items-center md:justify-between">
          <div className="md:w-1/2">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              <TranslatedText text="Sell with Ahavex" />
            </h1>
            <p className="text-lg md:text-xl mb-6 text-blue-100 max-w-xl">
              <TranslatedText 
                text="Partner with us to reach more customers and grow your business across Africa. We handle distribution while you focus on creating great products."
              />
            </p>
            <div className="flex flex-wrap gap-4">
              <Button size="lg" className="bg-ahavex-gold hover:bg-yellow-500 text-ahavex-blue">
                <TranslatedText text="Apply Now" />
              </Button>
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10">
                <TranslatedText text="Learn More" />
              </Button>
            </div>
          </div>
          <div className="mt-10 md:mt-0 md:w-1/2">
            <Card className="bg-white/10 backdrop-blur-sm border-none p-6 shadow-xl">
              <div className="flex items-center mb-4">
                <TrendingUp size={24} className="text-ahavex-gold mr-2" />
                <h3 className="text-xl font-semibold">
                  <TranslatedText text="Growth Opportunity" />
                </h3>
              </div>
              <p className="mb-4">
                <TranslatedText 
                  text="Sellers on Ahavex have seen an average of 40% increase in sales within the first 6 months."
                />
              </p>
              <div className="flex items-center">
                <Building size={24} className="text-ahavex-gold mr-2" />
                <h3 className="text-xl font-semibold">
                  <TranslatedText text="Business Partnership" />
                </h3>
              </div>
              <p>
                <TranslatedText 
                  text="Join 500+ businesses already selling through our platform across Rwanda and beyond."
                />
              </p>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellPortalHero;
